// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__AmTNu","buttonSet":"Settings_buttonSet__x7X5a","body":"Settings_body__o54Ue"};